//
//
//
//

import xshoucang from "../components/xshoucang.vue"
export default{
	components:{
		xshoucang
	}
}



// WEBPACK FOOTER //
// ./src/views/shoucang.vue